import type { AbnLiveState, AbnVerificationResult } from '../lib/useAbnVerification.ts';

/** Live indicator shown under an editable ABN field. */
export function AbnStatusIndicator({
  state,
  result,
}: {
  state: AbnLiveState;
  result: AbnVerificationResult | null;
}) {
  if (state === 'idle') return null;
  if (state === 'checking') {
    return <p className="mt-1 text-xs text-slate-500">Checking ABN…</p>;
  }
  if (state === 'verified') {
    return (
      <p className="mt-1 text-xs text-emerald-600">
        ✓ Verified{result?.entityName ? ` — ${result.entityName}` : ''}
      </p>
    );
  }
  if (state === 'invalid') {
    if (result?.registryStatus && result.registryStatus !== 'Active') {
      return (
        <p className="mt-1 text-xs text-amber-600">
          ⚠ ABN {result.registryStatus.toLowerCase()}
          {result.entityName ? ` — ${result.entityName}` : ''}
        </p>
      );
    }
    return <p className="mt-1 text-xs text-red-600">✗ Not a valid ABN</p>;
  }
  // 'unverified' — couldn't reach ABR / no GUID configured.
  return <p className="mt-1 text-xs text-slate-400">Couldn't verify right now</p>;
}

/** Persisted verdict badge from the stored company columns (read views). */
export function AbnVerifiedBadge({
  status,
  entityName,
  registryStatus,
}: {
  status: 'unverified' | 'verified' | 'invalid' | null;
  entityName: string | null;
  registryStatus: string | null;
}) {
  if (!status || status === 'unverified') {
    return <span className="text-xs text-slate-400">Not verified</span>;
  }
  if (status === 'verified') {
    return (
      <span className="text-xs text-emerald-600">
        ✓ Verified{entityName ? ` — ${entityName}` : ''}
      </span>
    );
  }
  if (registryStatus && registryStatus !== 'Active') {
    return (
      <span className="text-xs text-amber-600">
        ⚠ {registryStatus}
        {entityName ? ` — ${entityName}` : ''}
      </span>
    );
  }
  return <span className="text-xs text-red-600">✗ Not a valid ABN</span>;
}
